import { Accordion, Card } from "#/atoms";
import { FC, memo } from "react";

import { HeadingIcon } from "#/molecules/HeadingIcon";
import { VirtualStagingFurnitureCardProps } from "./VirtualStagingFurniture.interface";
import VirtualStagingFurnitureFields from "./VirtualStagingFurnitureFields";

const VirtualStagingFurnitureCard: FC<VirtualStagingFurnitureCardProps> = ({
  accordionState = 'open',
  externalUrl,
  furnitureNames,
  isAdmin,
  onAddFurnitures,
  onChangeUrl,
  orderServiceId
}) => {


  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="services" title="Virtual Staging" />}
        showArrow
        state={accordionState}
      >
        <VirtualStagingFurnitureFields
          externalUrl={externalUrl}
          furnitureNames={furnitureNames}
          isAdmin={isAdmin}
          onAddFurnitures={onAddFurnitures}
          onChangeUrl={onChangeUrl}
          orderServiceId={orderServiceId} />
      </Accordion>
    </Card>
  );
};

export default memo(VirtualStagingFurnitureCard);